import React from "react";
import { Button } from "../ui/button";
import { Bell, ClipboardList, Wallet, UserCheck, ArrowRight } from "lucide-react";
import { MAIN_APP_URL } from "../../lib/config";

const BENEFITS = [
  {
    icon: Bell,
    title: "Instant job notifications near you",
    body: "See jobs in your postcode the moment they're posted. Quote in seconds, not hours.",
  },
  {
    icon: ClipboardList,
    title: "Digital duty-of-care receipts",
    body: "A digital receipt for every job, generated automatically.",
  },
  {
    icon: Wallet,
    title: "Set your own prices",
    body: "You quote the number. Payouts go to your UK bank account through Stripe.",
  },
  {
    icon: UserCheck,
    title: "Show you're registered",
    body: "Carrier profiles show their registration details.",
  },
];

export default function ForCarriers() {
  return (
    <section
      id="for-carriers"
      className="relative py-24 md:py-32 bg-gradient-to-br from-moss-950 via-moss-900 to-moss-950 text-cream-50 overflow-hidden"
      data-testid="for-carriers"
    >
      <div
        aria-hidden
        className="absolute -top-32 -right-24 w-[520px] h-[520px] rounded-full bg-sage-600/20 blur-3xl"
      />
      <div
        aria-hidden
        className="absolute -bottom-40 -left-24 w-[520px] h-[520px] rounded-full bg-sage-500/15 blur-3xl"
      />

      <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-3xl">
          <p className="text-[11px] font-semibold tracking-[0.18em] uppercase text-sage-300">
            For waste carriers
          </p>
          <h2 className="font-display mt-3 text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-[1.02] text-balance">
            More jobs.{" "}
            <span className="text-sage-300">Less admin.</span>{" "}
            More money.
          </h2>
          <p className="mt-6 text-lg text-cream-100/80 leading-relaxed max-w-2xl">
            Join local carriers already signing up to Binshare.
          </p>
          <p
            className="mt-3 text-lg font-semibold text-sage-300 leading-relaxed max-w-2xl"
            data-testid="carrier-fee-statement"
          >
            Binshare takes just 5% on completed jobs, with no other fees.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 gap-6 lg:gap-8">
          {BENEFITS.map((b) => {
            const Icon = b.icon;
            return (
              <div
                key={b.title}
                className="rounded-3xl bg-cream-50/5 border border-cream-50/10 backdrop-blur p-6 lg:p-8 hover:bg-cream-50/10 transition-colors"
                data-testid={`carrier-benefit-${b.title.toLowerCase().split(" ").slice(0, 2).join("-")}`}
              >
                <div className="w-12 h-12 rounded-xl bg-sage-500/20 border border-sage-400/25 flex items-center justify-center">
                  <Icon className="w-6 h-6 text-sage-300" strokeWidth={2.25} />
                </div>
                <h3 className="font-display mt-5 text-xl font-bold leading-tight">
                  {b.title}
                </h3>
                <p className="mt-2 text-cream-100/70 leading-relaxed">
                  {b.body}
                </p>
              </div>
            );
          })}
        </div>

        <div className="mt-14">
          <a
            href={MAIN_APP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="carrier-register-cta"
          >
            <Button className="h-14 px-8 rounded-full bg-sage-500 hover:bg-sage-400 text-moss-950 text-base font-bold shadow-lg shadow-sage-500/25">
              Register as a carrier
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
}
